import * as React from 'react';
import { useState, useEffect } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import Searchbar from 'src/layouts/dashboard/Searchbar';
import {
  Card,
  Table,
  Stack,
  Box,
  Button,
  TableRow,
  TableBody,
  TableCell,
  Container,
  Typography,
  TableContainer,
  Modal,
  CircularProgress,
  Pagination,
  Avatar,
  TextField,
  MenuItem,
  Checkbox,
  Tooltip,
  Drawer,
  IconButton
} from '@mui/material';
import Label from 'src/components/Label';
import { LoadingButton } from '@mui/lab';
import pallete from '../theme/palette';
import Page from '../components/Page';
import Scrollbar from '../components/Scrollbar';
import Iconify from '../components/Iconify';
import SearchNotFound from '../components/SearchNotFound';
import { UserListHead } from '../sections/@dashboard/user';
import { api } from '../Api';
import { useTranslation } from 'react-i18next';
import ChangeProductStatus from 'src/sections/@dashboard/products/ChangeJobStatus';
import BulkEdit from 'src/sections/@dashboard/products/BulkStatusEdit';
import JobsOfferModal from 'src/sections/@dashboard/products/JobsOfferModal';
import JobDetailModal from 'src/sections/@dashboard/products/JobDetailModal';
import ChangeJobStatus from 'src/sections/@dashboard/products/ChangeJobStatus';
import CloseIcon from '@mui/icons-material/Close';
import Slider from '@mui/material/Slider';
import GooglePlaces from 'src/components/GooglePlaces';
import palette from '../theme/palette';
import { green } from '@mui/material/colors';

export default function Jobs() {
  const [statusss, setStatus] = useState('');
  const [statusList, setStatuslist] = useState([]);
  const [sorting, setsorting] = useState('');
  const [sortinglist, setsortinglist] = useState([
    { id: 1, code: 'date_newest_first', name: 'Date:  New to Old' },
    { id: 2, code: 'date_oldest_first', name: 'Date:  Old to New ' },
    { id: 3, code: 'salary_max_to_min', name: 'Salary: High to Low' },
    { id: 4, code: 'salary_min_to_max', name: 'Salary: Low to High' }
    // { id: 5, code: 'a_to_z', name: 'Name:  A to Z' },
    // { id: 6, code: 'z_to_a', name: 'Name:  Z to A' }
  ]);
  const [user, setuser] = useState('');
  const { t } = useTranslation();
  const TABLE_HEAD = [
    // { id: 'Select', label: 'Select All', alignRight: false },
    { id: 'Company', label: 'Company', alignRight: false },
    { id: 'jobtitle', label: 'Job Title', alignRight: false },
    { id: 'category', label: 'Category', alignRight: false },
    { id: 'salary', label: 'Salary', alignRight: false },
    { id: 'location', label: 'Location', alignRight: false },
    { id: 'status', label: 'Status', alignRight: false },
    { id: 'action', label: 'Action', alignRight: false }
  ];
  const [bulkstatus, setbulkstatus] = useState('');
  const [permission, setpermission] = useState([]);
  const requirement = ['visible', 'change status'];
  const [selected, setSelected] = useState([]);
  const [openDrawer, setOpenDrawer] = React.useState(false);
  const [price, setprice] = useState([0, 50000]);
  function checkRender() {
    let check = 'jobs';
    const localPerm = JSON.parse(localStorage.getItem('permissions'))?.filter(
      (item) => item.permission_name.toLowerCase() == check
    );
    localPerm[0].permission_types.filter((items) =>
      requirement.includes(items.permission_type_name.toLowerCase())
        ? setpermission((permissions) => [...permissions, items.permission_type_name.toLowerCase()])
        : false
    );
  }
  const handleChangePrice = (newValue, type) => {
    type == 'price' && setprice(newValue);
  };

  useEffect(() => {
    checkRender();
  }, []);

  const detailClose = () => {
    setDetail(false);
  };

  const [list, setlist] = useState([]);
  const [detail, setDetail] = React.useState(false);
  const [loading, setloading] = useState(true);
  const [btnloading, setbtnloading] = useState(false);
  const [search, setsearch] = useState('');
  const [searchLoading, setsearchLoading] = useState(false);
  const [address, setaddress] = useState('');
  const [jobcategorylist, setjobcategorylist] = useState([]);
  const [jobcategory, setjobcategory] = useState('');
  const [companylist, setcompanylist] = useState([]);
  const [companyname, setcompanyname] = useState('');
  // useEffect(() => {
  //   setreason('');
  //   setloading(true);
  //   getJobs(page, statusss, sorting);
  // }, []);

  const [reason, setreason] = useState('');

  useEffect(() => {
    getJobCategory();
    getJobCompanyName();
  }, []);
  const getJobCategory = () => {
    setbtnloading(true);
    const token = localStorage.getItem('token');

    const requestOptions = {
      method: 'GET'
    };
    fetch(api.get_job_categories, requestOptions)
      .then((response) => {
        if (response.status === 200) {
          return response.text();
        } else {
          throw new Error('Failed to get product');
        }
      })
      .then((result_) => {
        const result = JSON.parse(result_);
        setjobcategorylist(result?.data);
      })
      .catch((error) => console.log('error', error))
      .finally(() => {});
  };

  const getJobCompanyName = () => {
    setbtnloading(true);
    const token = localStorage.getItem('token');
    const myHeaders = new Headers();
    myHeaders.append('Authorization', `Bearer ${token}`);
    const requestOptions = {
      method: 'GET',
      headers: myHeaders
    };
    fetch(api.get_companies, requestOptions)
      .then((response) => {
        if (response.status === 200) {
          return response.text();
        } else {
          throw new Error('Failed to get product');
        }
      })
      .then((result_) => {
        const result = JSON.parse(result_);
        setcompanylist(result?.data);
      })
      .catch((error) => console.log('error', error))
      .finally(() => {});
  };

  function getJobs(pagenumber, state, sort) {
    const token = localStorage.getItem('token');
    const myHeaders = new Headers();
    myHeaders.append('Authorization', `Bearer ${token}`);
    // Build the query parameters
    const params = new URLSearchParams();
    pagenumber && params.append('page', pagenumber);
    search.length > 0 && params.append('search', search);
    state && state.name != 'All' && params.append('status', state.name);
    sort && params.append('orderBy', sort.code);
    // sort ? params.append('orderBy', sort.code) : params.append('orderBy', 'date_newest_first');
    address && address?.country && params.append('country', address?.country);
    address && address?.city && params.append('city', address?.city);
    address && address?.state && params.append('state', address?.state);
    if (price.length > 0) {
      if (price[0] > 0 && price[0] <= 50000) {
        params.append('min_salary', price[0]);
      }
      if (price[1] > 0 && price[1] < 50000) {
        params.append('max_salary', price[1]);
      }
    }
    jobcategory && params.append('job_category_id', jobcategory?.id);
    companyname && params.append('company_name', companyname?.name);
    params.append('is_admin', true);
    const requestOptions = {
      method: 'GET',
      headers: myHeaders,
      redirect: 'follow'
    };
    const url = `${api.get_jobs}?${params.toString()}`;
    fetch(url, requestOptions)
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else {
          throw new Error('Failed to fetch products');
        }
      })
      .then((result) => {
        setlist(result.data);

        // result?.count ? setpagesCount(Math.ceil(result?.count / 20)) : setpagesCount(1);
        result?.pagination
          ? setpagesCount(Math.ceil(result?.pagination?.total / 20))
          : setpagesCount(1);
      })
      .catch((error) => {
        setlist([]);
        setpagesCount(0);
      })
      .finally(() => {
        setsearchLoading(false);
        setloading(false);
      });
  }

  useEffect(() => {
    getStatus();
  }, []);

  function getStatus() {
    // setloading(true);
    const myHeaders = new Headers();
    const token = localStorage.getItem('token');

    myHeaders.append('Authorization', `Bearer ${token}`);
    const params = new URLSearchParams();
    params.append('type', 'job');
    const requestOptions = {
      method: 'GET',
      headers: myHeaders,
      redirect: 'follow'
    };
    fetch(`${api.get_user_status}?${params.toString()}`, requestOptions)
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else {
          throw new Error(`Error: ${response.status}`);
        }
      })
      .then((result) => {
        let allvals = [{ id: 333, name: 'All' }, ...result.data];
        setStatuslist(allvals);
        setStatus(allvals.find((item) => item.id === 333));
      })
      .catch((error) => {
        console.log('error', error);
        setStatuslist([]);
      })
      .finally(() => {
        //  setloading(false);
      });
  }

  const refresh = () => {
    setDetail(false);
    getJobs(page);
  };

  // useEffect(() => {
  //   if (sorting == '') {
  //     setsorting(sortinglist[0]);
  //   }
  // }, [sorting]);

  const [product, setproduct] = useState(null);

  function openModal(row) {
    setproduct(row);
    setDetail(true);
  }

  function closeandOpen() {
    setDetail(false);
  }

  const tableRef = React.createRef();

  const [pagesCount, setpagesCount] = useState(1);
  const [page, setPage] = React.useState(1);

  const handlePageChange = (event, value) => {
    setloading(true);
    list.length = 0;
    setPage(value);
    getJobs(value, statusss, sorting);
  };

  const [editbulk, seteditbulk] = useState(false);

  const [statusModal, setstatusModal] = useState(false);

  function openStatusModal(row) {
    setproduct(row);
    setstatusModal(true);
  }

  const refreshAdmin = () => {
    setstatusModal(false);
    setloading(true);
    list.length = 0;
    setlist([]);
    getJobs(page, statusss, sorting); //YAHAN KRNA HAI
    seteditbulk(false);
  };

  useEffect(() => {
    if (address) {
      setloading(true);
      list.length = 0;
      setPage(1);
      getJobs(1, statusss, sorting);
    } else {
      if (!address) {
        setloading(true);
        list.length = 0;
        setPage(1);
        getJobs(1, statusss, sorting);
      }
    }
  }, [address]);

  useEffect(() => {
    if (search.length == 0) {
      setloading(true);
      list.length = 0;
      setPage(1);
      getJobs(1, statusss, sorting);
    }
  }, [search]);

  const style = {
    display: 'flex',
    height: '100%',
    width: '100%',
    justifyContent: 'center',
    alignItems: 'center'
  };

  const boxStyle = {
    minWidth: '70%',
    maxHeight: '90%',
    bgcolor: 'background.paper',
    boxShadow: 24,
    overflow: 'auto',
    border: '2px solid',
    borderColor: pallete.primary.main
  };

  // OFFER MODAL VARIABLES AND FUNCTION

  const [offerModal, setOfferModal] = useState(false);

  const offerClose = () => {
    setOfferModal(false);
  };

  function openOfferModal(row) {
    setproduct(row);
    setOfferModal(true);
  }

  const handleChangeJobCategory = (event) => {
    setjobcategory(event.target.value);
    // getJobs(1, newstate, sorting);
  };

  const handlesorting = (event) => {
    const newsort = event.target.value;
    setsorting(newsort);
  };

  const handlefilterstatus = (event) => {
    const newvalue = event.target.value;
    setStatus(newvalue);
  };

  const handlecompanyname = (event) => {
    setcompanyname(event.target.value);
  };
  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = list
        .filter((n) => n?.status?.toLowerCase() !== 'declined')
        .map((n) => n.id);
      setSelected(newSelecteds);
      return;
    } else {
      setSelected([]);
    }
  };

  const handleSelect = (id) => {
    if (selected.includes(id)) {
      // Remove the ID from the array
      setSelected(selected.filter((item) => item !== id));
    } else {
      // Add the ID to the array
      setSelected([...selected, id]);
      // setSelected([]);
    }
  };
  const isDataFound = list.length === 0;

  const getStatusColor = (status) => {
    switch (status?.toLowerCase()) {
      case 'active':
        return 'success';
      case 'deleted':
        return 'error';
      case 'pending':
        return 'info';
      case 'hired':
        return 'warning';
      case 'paused':
        return 'default';
      default:
        return 'primary';
    }
  };

  function valuetext(value) {
    return `${value}°C`;
  }

  useEffect(() => {
    if (!sorting && !companyname && price && !jobcategory && !statusss) {
      getJobs(1);
    }
  }, [sorting, companyname, price, jobcategory]);

  return (
    <Page title={`Jobs | ${process.env.REACT_APP_PROJECTNAME}`}>
      <Container>
        {/* PRODUCT OFFER MODAL */}
        <Modal style={style} open={offerModal} onClose={offerClose}>
          <Box sx={{ ...boxStyle, p: 0, minWidth: '70%' }} className="admin_modal_pa">
            <JobsOfferModal handleClose={offerClose} product_id={product} />
          </Box>
        </Modal>
        {/* PRODUCT DETAIL MODAL */}
        <Modal style={style} open={detail} onClose={detailClose}>
          <Box
            sx={{ ...boxStyle, p: 0, minWidth: '70%', minHeight: '80%' }}
            className="admin_modal_pa"
          >
            <JobDetailModal
              handleClose={detailClose}
              details={product}
              refresh={refresh}
              closeandOpen={closeandOpen}
            />
          </Box>
        </Modal>
        {/* CHANGE STATUS MODAL */}
        <Modal
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100%',
            width: '100%'
          }}
          open={statusModal}
          onClose={() => {
            setstatusModal(false);
          }}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box
            sx={{
              maxWidth: '40%',
              maxHeight: '90%',
              bgcolor: 'background.paper',
              boxShadow: 24,
              overflow: 'auto',
              border: '2px solid',
              borderColor: pallete.primary.main
              // style
            }}
            className="admin_modal_pa"
          >
            <ChangeJobStatus
              property={product}
              handleClose={() => {
                setstatusModal(false);
              }}
              refreshAdmin={refreshAdmin}
            />
          </Box>
        </Modal>

        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={1}>
          <Typography variant="h4" gutterBottom>
            Jobs
          </Typography>
        </Stack>
        <Drawer
          classes={{
            paper: 'width_drawer'
          }}
          anchor={'right'}
          open={openDrawer}
          onClose={() => {
            setOpenDrawer(false);
          }}
        >
          <Box pb={2} className="cross_drawer">
            <IconButton
              aria-label="close"
              style={{
                position: 'absolute',
                right: 5,
                marginBottom: 10,
                marginRight: 10
              }}
              onClick={() => {
                setOpenDrawer(false);
              }}
            >
              <CloseIcon />
            </IconButton>
          </Box>

          <Box
            mt={3}
            p={1}
            style={{
              flexDirection: 'row',
              display: 'flex',
              flexWrap: 'wrap',
              width: '90%',
              alignSelf: 'center'
            }}
          >
            <Typography style={{ marginTop: 5, fontSize: 16 }}>Salary Range</Typography>

            <Slider
              getAriaLabel={() => 'Temperature range'}
              value={price}
              onChange={(e, val) => {
                handleChangePrice(val, 'price');
              }}
              valueLabelDisplay="auto"
              getAriaValueText={valuetext}
              min={0}
              max={50000}
              defaultValue={1000000}
              step={100}
              size="small"
            />
          </Box>
          {/* <status filter> */}
          <Box
            p={1}
            style={{
              flexDirection: 'row',
              display: 'flex',
              flexWrap: 'wrap',
              width: '90%',
              alignSelf: 'center'
            }}
          >
            <TextField
              fullWidth
              select
              value={statusss}
              label={'Status'}
              onChange={handlefilterstatus}
              className="width_full_status"
            >
              {statusList.map((option) => (
                <MenuItem key={option.id} value={option}>
                  {option.name}
                </MenuItem>
              ))}
            </TextField>

            <TextField
              fullWidth
              style={{
                marginTop: 20
              }}
              select
              value={jobcategory}
              label={'Job Category'}
              onChange={handleChangeJobCategory}
              className="width_full_status"
            >
              {jobcategorylist.map((option) => (
                <MenuItem key={option.id} value={option}>
                  {option.name}
                </MenuItem>
              ))}
            </TextField>

            <TextField
              fullWidth
              style={{
                marginTop: 20
              }}
              select
              value={sorting}
              label={'Sort by'}
              onChange={handlesorting}
              className="width_full_status"
            >
              {sortinglist.map((option) => (
                <MenuItem key={option.id} value={option}>
                  {option.name}
                </MenuItem>
              ))}
            </TextField>

            <TextField
              fullWidth
              style={{
                marginTop: 20
              }}
              select
              value={companyname}
              label={'Company Name'}
              onChange={handlecompanyname}
              className="width_full_status"
            >
              {companylist.map((option) => (
                <MenuItem key={option.id} value={option}>
                  {option.name}
                </MenuItem>
              ))}
            </TextField>
          </Box>
          <Box style={{ width: '90%', alignSelf: 'center', marginTop: 20, marginBottom: 20 }}>
            <Button
              onClick={(event) => {
                setprice([0, 50000]);
                setsorting(null);
                setcompanyname(null);
                setjobcategory(null);
                setStatus(null);
              }}
              variant="outlined"
              component={RouterLink}
              to="#"
              fullWidth
              style={{ height: 50, marginBottom: 15 }}
            >
              Clear All
            </Button>
            <Button
              onClick={(event) => {
                list.length = 0;
                setOpenDrawer(false);
                setloading(true);
                setPage(1);
                getJobs(1, statusss, sorting);
              }}
              variant="contained"
              component={RouterLink}
              to="#"
              fullWidth
              style={{ height: 50 }}
            >
              Apply Filters
            </Button>
          </Box>
        </Drawer>
        <Card
          sx={{
            bgcolor: '#151921',
            color: '#fff',
            borderRadius: 2,
            boxShadow: '0px 4px 20px rgba(0,0,0,0.4)'
          }}
        >
          <Box
            p={2}
            style={{
              flexDirection: 'row',
              display: 'flex',
              flex: 1,
              justifyContent: 'space-between'
            }}
            className="top_options"
          >
            <Searchbar
              width={'40%'}
              value={search}
              setFunction={(val) => {
                setsearch(val);
              }}
              placeholder={t('Agents.search') + '...'}
              onEnter={() => {
                setsearchLoading(true);
                getJobs(1, statusss, sorting);
              }}
            />
            <GooglePlaces
              width={'40%'}
              onResult={(val) => {
                setaddress(val);
              }}
              regions={true}
              placeholder={t('Property.loc')}
            />

            <LoadingButton
              style={{ width: '4%' }}
              // style={{ width: '15%', marginLeft: '2.5%' }}
              variant="contained"
              loading={searchLoading}
              onClick={() => {
                setsearchLoading(true);
                setPage(1);
                list.length = 0;
                getJobs(1);
              }}
              className="width_full"
            >
              <Iconify icon="material-symbols:search" sx={{ width: 25, height: 25 }} />
            </LoadingButton>

            <LoadingButton
              style={{ width: '4%' }}
              variant="contained"
              //   loading={searchLoading}
              onClick={() => {
                setOpenDrawer(true);
              }}
              className="width_full"
            >
              <Iconify icon="ion:filter" sx={{ width: 25, height: 25 }} />
            </LoadingButton>
            {/* </CardContent> */}
          </Box>
          <Scrollbar>
            <TableContainer sx={{ minWidth: 800 }}>
              <Table ref={tableRef}>
                <UserListHead
                  onClick={handleSelect}
                  onSelectAllClick={handleSelectAllClick}
                  headLabel={TABLE_HEAD}
                  rowCount={list.length}
                  allSelect={
                    selected.length ==
                      list.filter((item) => item?.status?.toLowerCase() != 'declined').length &&
                    !selected.length == 0
                  }
                />

                <TableBody>
                  {list.map((row) => {
                    const {
                      id,
                      name,
                      title,
                      job_category,
                      salary,
                      location,
                      status,
                      media,
                      company,
                      currency
                    } = row;
                    // console.log('===========log', row);
                    // const colorNames = colors?.map((color) => color?.name).join(',');
                    // const sizesNames = sizes?.map((size) => size?.name).join(',');

                    return (
                      <TableRow key={id}>
                        {/* NAME */}
                        <TableCell scope="row" padding="normal" style={{ width: 250 }}>
                          <Stack direction="row" alignItems="center" spacing={1}>
                            <Avatar
                              alt={name}
                              src={company?.avatar ? company?.avatar : ''}
                              // src={
                              //   media?.length > 0
                              //     ? media[0]?.uri
                              //     : 'https://media.istockphoto.com/id/1128229893/vector/shopping-cart-icon.jpg?s=612x612&w=0&k=20&c=EunmrZqRD5SXHNtqUBNkDl0zJGgq7QUjw2KXlbR6_Dg='
                              // }
                              style={{ width: 50, height: 50, borderRadius: 30 }}
                            />
                            <div className="one-line-ellipsis">{company?.name || 'N/A'}</div>
                          </Stack>
                        </TableCell>
                        {/* CATEGORY */}
                        <TableCell align="left">
                          <Typography fontSize={12}>{title || 'N/A'}</Typography>
                        </TableCell>
                        {/* BRAND */}
                        <TableCell align="left">
                          <Typography fontSize={12}>{job_category?.name || 'N/A'}</Typography>
                        </TableCell>
                        {/* CONDITION */}
                        <TableCell align="left" sx={{ whiteSpace: 'nowrap' }}>
                          {/* <Typography fontSize={12}>{salary || 'N/A'}</Typography> */}
                          <Typography fontSize={12}>{`${salary} ${currency}` || 'N/A'}</Typography>
                        </TableCell>

                        {/* CONDITION */}
                        <TableCell align="left">
                          <Typography fontSize={12}>{location || 'N/A'}</Typography>
                        </TableCell>

                        {/* STATUS */}
                        <TableCell
                          align="left"
                          style={{ maxWidth: 150, justifyContent: 'center', textAlign: 'center' }}
                        >
                          {status ? (
                            <Label
                              style={{
                                height: 30,
                                paddingLeft: 5,
                                paddingRight: 5,
                                width: 80
                              }}
                              variant="ghost"
                              // color={(status === 'Declined' && 'error') || 'success'}

                              color={getStatusColor(status)}
                            >
                              <Typography
                                style={{
                                  textTransform: 'capitalize',
                                  fontWeight: 'bold',
                                  fontSize: 12,
                                  color: status.toLowerCase() === 'paused' ? 'grey' : 'inherit'
                                }}
                              >
                                {status}
                              </Typography>
                            </Label>
                          ) : (
                            <Typography
                              style={{
                                textTransform: 'capitalize',
                                fontWeight: 'bold',
                                fontSize: 12
                              }}
                            >
                              N/A
                            </Typography>
                          )}
                        </TableCell>
                        {/* ACTIONS */}
                        <TableCell style={{ position: 'relative', minHeight: 400 }}>
                          <Box
                            display="flex"
                            flexDirection="row"
                            m={0}
                            sx={{ alignItems: 'center' }}
                          >
                            {permission.includes('visible') && (
                              <Tooltip title="Details">
                                <LoadingButton
                                  // disabled={row?.status?.toLowerCase() == 'deleted'}
                                  size="small"
                                  onClick={(event) => {
                                    event.preventDefault();
                                    event.stopPropagation();
                                    openModal(row);
                                  }}
                                  style={{
                                    justifyContent: 'center',
                                    width: 30, // Less than 30
                                    height: 30, // Ensuring it's a square button
                                    minWidth: 30, // Ensuring minimum width is set to 30
                                    padding: 0, // Removing padding to fit the icon properly
                                    lineHeight: 1, // Ensuring the icon is centered
                                    alignSelf: 'center',
                                    marginLeft: 1
                                  }}
                                  to="#"
                                >
                                  <Iconify
                                    style={{ cursor: 'pointer', fontSize: 18 }}
                                    icon="gg:notes"
                                  />
                                </LoadingButton>
                              </Tooltip>
                            )}
                            {permission.includes('change status') && (
                              <Tooltip title="Change Status">
                                <LoadingButton
                                  disabled={row?.status?.toLowerCase() == 'deleted'}
                                  size="small"
                                  onClick={() => openStatusModal(row)}
                                  style={{
                                    justifyContent: 'center',
                                    width: 30, // Less than 30
                                    height: 30, // Ensuring it's a square button
                                    minWidth: 30, // Ensuring minimum width is set to 30
                                    padding: 0, // Removing padding to fit the icon properly
                                    lineHeight: 1, // Ensuring the icon is centered
                                    alignSelf: 'center',
                                    marginLeft: 1
                                  }}
                                  to="#"
                                >
                                  <Iconify
                                    style={{ cursor: 'pointer', fontSize: 18 }}
                                    icon="tabler:status-change"
                                  />
                                </LoadingButton>
                              </Tooltip>
                            )}
                            {/* {permission.includes('view offers') && (
                              <Tooltip title="View Offers">
                                <Iconify
                                  style={{
                                    marginRight: 5,
                                    cursor: 'pointer',
                                    fontSize: 20
                                  }}
                                  color={pallete.primary.main}
                                  icon="carbon:view-filled"
                                  onClick={() => openOfferModal(row?.id)}
                                />
                              </Tooltip>
                            )} */}
                          </Box>
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
                {isDataFound && !loading && (
                  <TableBody>
                    <TableRow>
                      <TableCell align="center" colSpan={12} sx={{ py: 3 }}>
                        <SearchNotFound searchQuery={search} />
                      </TableCell>
                    </TableRow>
                  </TableBody>
                )}
              </Table>
              {loading && !searchLoading && (
                <Box
                  py={5}
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    flex: 1
                  }}
                >
                  <CircularProgress />
                </Box>
              )}
            </TableContainer>
          </Scrollbar>
        </Card>
        {!loading && !searchLoading && pagesCount > 1 && (
          <Box
            style={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'flex-end',
              marginTop: 10,
              alignItems: 'center'
            }}
          >
            <Pagination
              count={pagesCount}
              color="primary"
              variant="outlined"
              shape="rounded"
              onChange={handlePageChange}
              page={page}
            />
          </Box>
        )}
      </Container>
    </Page>
  );
}
